import SockJS from 'sockjs-client';
import { Stomp } from '@stomp/stompjs';

export default class WebSocketService {
    constructor() {
        this.socket = null;
        this.stompClient = null;
    }

    // 连接 WebSocket
    connect(header,url,username, onMessageCallback) {
        // 连接 WebSocket 服务器
        this.socket = new SockJS(url);  // WebSocket 服务的端点
        this.stompClient = Stomp.over(this.socket);
        this.stompClient.debug = ()=>{};// 关闭日志
        this.stompClient.connect(header, (frame) => {
            console.log('链接成功: ' + frame);

            // 订阅特定用户的消息队列
            this.stompClient.subscribe(`/user/${username}/queue/notify`, (message) => {
                onMessageCallback(message.body);  // 当收到消息时，执行回调函数
            });
        });
    }

    // 发送消息到服务器
    sendMessage(message) {
        this.stompClient.send('/app/sendMessage', {}, message);  // 向 Spring Boot 后端发送消息
    }

    // 断开连接
    disconnect() {
        if (this.stompClient !== null) {
            this.stompClient.disconnect();
        }
        console.log('Disconnected');
    }
}
